export const imageUrl = "https://oevent-data.s3.me-central-1.amazonaws.com/oEventUploads/upload/"
export const imageSize = "thumbnail/512x512"
// https://oevent-data.s3.me-central-1.amazonaws.com/oEventUploads
// profileImg : upload/profile
// chatDocs : upload/chat
// vandorCategory : upload/category
// privacyPolicy : "upload/policy",
// TICKETIMG:"upload/ticketDoc"
// BUSINESSERVIMG: "upload/businessServiceImg"
// VENDORSERVIMG: "upload/vendorServiceImg"
// VENDORBANKDOC: "upload/vendorBankDoc"

export const TableController = { page: 1, rowsPerPage: 10, searchPage: 1, sortValue: null, sortOrder: -1, }
export const modalEnum = { open: false, data: null }
export const activeStatusOption = [
  { value: 'ALL', label: "All" },
  { value: true, label: "Active" },
  { value: false, label: "In-Active" },
]
export const defaultMarker = {
  address: "Sahibzada Ajit Singh Nagar, Punjab, India",
  coords: { lat: 30.7046486, lng: 76.71787259999999 }
};

export const applicableQuantity = (t) => [
  { label: `${t("dropdown.yes")}`, value: true },
  { label: `${t("dropdown.no")}`, value: false, }
]

export const vendorListFilterOption = [
  { value: "DISABLE", label: "Disabled Vendor" },
  { value: "DELETE", label: "Deleted vendor" },
]
export const extraChargesOption = [
  { value: "5", label: "5" },
  { value: "10", label: "10" },
  { value: '15', label: "15" },
]
export const locationExtraChargesOption = [
  { value: "10", label: "10%" },
  { value: '20', label: "20%" },
]
export const serviceCategoryOption = [
  { value: "Event", label: "Event" },
  { value: 'Event2', label: "Event2" },
]

export const planDurationList = [
  { title: "Monthly", value: "MONTHLY" },
  { title: "Yearly", value: "YEARLY" },
]
export const planTypeList = [
  { title: "Flat Rate", value: "FLAT_RATE" },
  { title: "Commission Based", value: "COMM_BASED" },
]
export const paymentTypeList = [
  { title: "Advance", value: "ADVANCE" },
  { title: "Full", value: "FULL" },
  { title: "Partial", value: "PARTIAL" },
]


// export const statusDataList = [
//   { title: "Active", value: true },
//   { title: "In-Active", value: false },
// ]

export const getStatusDataList = (t) => [
  { title: t("optionTitle.active"), value: true },
  { title: t("optionTitle.inactive"), value: false },
];

export const subEventCategoryOptions = [
  {id: 1, key: "music_festival", value: "Music Festivals", label: "Music Festivals" },
  {id: 2, key: "circus_special", value: "Circus & Special Performances", label: "Circus & Special Performances" },
  {id: 3, key: "dj_club", value: "DJ & Club Events", label: "DJ & Club Events" },
  {id: 4, key: "matches", value: "Matches (Football/Basketball/etc)", label: "Matches (Football/Basketball/etc)" },
  {id: 5, key: "fitness", value: "Fitness Classes & Competitions", label: "Fitness Classes & Competitions" },
  {id: 6, key: "racing", value: "Racing Events (Car/Bike Races, Marathons)", label: "Racing Events (Car/Bike Races, Marathons)" },
  {id: 7, key: "business_tech", value: "Business & Tech Conferences", label: "Business & Tech Conferences" },
  {id: 8, key: "education_training", value: "Educational & Training Workshops", label: "Educational & Training Workshops" },
  { id: 9, key: "art_culture", value: "Art & Cultural Exhibitions", label: "Art & Cultural Exhibitions" },
  {id: 10, key: "gala_dinner", value: "Gala Dinners & Exclusive Parties", label: "Gala Dinners & Exclusive Parties" },
  {id: 11, key: "networking_corporate", value: "Networking & Corporate Events", label: "Networking & Corporate Events" },
  {id: 12, key: "other", value: "Other", value: "Other", label: "Other" }
];

export const subEventCategoryOptions_ar = [
  {id: 1, key: "music_festival", value: "مهرجانات موسيقية", label: "مهرجانات موسيقية" },
  {id: 2, key: "circus_special", value: "سيرك وعروض خاصة", label: "سيرك وعروض خاصة" },
  {id: 3, key: "dj_club", value: "فعاليات منسقي الأغاني والأندية", label: "فعاليات منسقي الأغاني والأندية" },
  { id: 4, key: "matches", value: "مباريات (كرة قدم/كرة سلة/إلخ)", label: "مباريات (كرة قدم/كرة سلة/إلخ)" },
  {id: 5, key: "fitness", value: "دروس ومسابقات لياقة بدنية", label: "دروس ومسابقات لياقة بدنية" },
  {id: 6, key: "racing", value: "فعاليات سباقات (سباقات سيارات/دراجات، ماراثون)", label: "فعاليات سباقات (سباقات سيارات/دراجات، ماراثون)" },
  {id: 7, key: "business_tech", value: "مؤتمرات أعمال وتكنولوجيا", label: "مؤتمرات أعمال وتكنولوجيا" },
  {id: 8, key: "education_training", value: "ورش عمل تعليمية وتدريبية", label: "ورش عمل تعليمية وتدريبية" },
  { id: 9, key: "art_culture", value: "معارض فنية وثقافية", label: "معارض فنية وثقافية" },
  {id: 10, key: "gala_dinner", value: "حفلات عشاء وحفلات خاصة", label: "حفلات عشاء وحفلات خاصة" },
  {id: 11, key: "networking_corporate", value: "فعاليات اجتماعية وفعاليات للشركات", label: "فعاليات اجتماعية وفعاليات للشركات" },
  {id: 12, key: "other", value: "Other", value: "أخرى", label: "أخرى" }
];


// export const subEventCategoryOptions_ar = [
//   { value: "Music Festivals", label: "Music Festivals" },
//   { value: "Circus & Special Performances", label: "Circus & Special Performances" },
//   { value: "DJ & Club Events", label: "DJ & Club Events" },
//   { value: "Matches (Football/Basketball/etc)", label: "Matches (Football/Basketball/etc)" },
//   { value: "Fitness Classes & Competitions", label: "Fitness Classes & Competitions" },
//   { value: "Racing Events (Car/Bike Races, Marathons)", label: "Racing Events (Car/Bike Races, Marathons)" },
//   { value: "Business & Tech Conferences", label: "Business & Tech Conferences" },
//   { value: "Educational & Training Workshops", label: "Educational & Training Workshops" },
//   { value: "Art & Cultural Exhibitions", label: "Art & Cultural Exhibitions" },
//   { value: "Gala Dinners & Exclusive Parties", label: "Gala Dinners & Exclusive Parties" },
//   { value: "Networking & Corporate Events", label: "Networking & Corporate Events" },
//   { value: "Other", label: "Other" }
// ];

export const bankNameList = [
  { title: "AHLI BANK S.A.O.G", value: "AUBOOMRUALH" },
  // { title: "AHLI BANK S.A.O.G", value: "AUBOOMRU" },
  { title: "ALIZZ ISLAMIC BANK", value: "IZZBOMRU" },
  { title: "BANK DHOFAR (S.A.O.G.)", value: "BDOFOMRU" },
  { title: "DHOFAR ISLAMIC (S.A.O.G.)", value: "BDOFOMRUMIB" },
  // { title: "BANK MUSCAT SAOG", value: "BMUSOMRX" },
  { title: "BANK MUSCAT SAOG", value: "BMUSOMRXISL" },
  { title: "BANK NIZWA", value: "BNZWOMRX" },
  { title: "BANK OF BARODA, GREATER MUTTRAH BRANCH", value: "BARBOMMXMUT" },
  // { title: "BANK OF BARODA, GREATER MUTTRAH BRANCH", value: "BARBOMMX" },
  // { title: "BANK OF BARODA, GREATER MUTTRAH BRANCH", value: "BARBOMMXSOH" },
  { title: "BANK OF BEIRUT S.A.L.- OMAN BRANCH", value: "BABEOMRX" },
  { title: "FIRST ABU DHABI BANK (FORMERLY NATIONAL BANK OF ABU DHABI) OMAN MAIN BR", value: "NBADOMRX" },
  { title: "GLOBAL FINANCIAL INVESTMENTS HOLDING", value: "GFISOMR1" },
  // { title: "GULF INTERNATIONAL BANK (OMAN BRANCH)", value: "GULFOMRX" },
  { title: "GULF INVESTMENT SERVICES CO. (S.A.O.G)", value: "GISCOMR1" },
  { title: "HSBC BANK MIDDLE EAST LIMITED(OMAN BRANCH)", value: "HBMEOMRX" },
  { title: "MINISTRY OF FINANCE", value: "MINIOMRU" },
  { title: "MUSCAT DEPOSITORY AND SECURITIES REGISTRATION CO SAOC", value: "MDSROMR1" },
  { title: "MUSCAT SECURITIES MARKET", value: "XMUSOMM1" },
  { title: "MUZN ISLAMIC BANKING TRADING UNDER NATIONAL BANK OF OMAN", value: "MUZNOMR1" },
  { title: "NATIONAL BANK OF OMAN", value: "NBOMOMRX" },
  { title: "OMAN ARAB BANK SAOG", value: "OMABOMRU" },
  { title: "AL IZZ ISLAMIC BANK", value: "IZZBOMRU" },
  { title: "OMAN INVESTMENT BANK SAOC", value: "OIBBOMRX" },
  { title: "QATAR NATIONAL BANK", value: "QNBAOMRX" },
  // { title: "SOHAR INTERNATIONAL BANK S.A.O.G", value: "BSHROMRU" },
  { title: "SOHAR INTERNATIONAL BANK S.A.O.G", value: "BSHROMRUISL" },
  { title: "STANDARD CHARTERED BANK", value: "SCBLOMRX" },
  { title: "STATE BANK OF INDIA, MUSCAT, OMAN", value: "SBINOMRX" },

]

export const fileTypes = {
  pdf_File_Type: ["application/pdf"],
  Img_Type: [
    "image/jpg",
    "image/jpeg",
    "image/pjp",
    "image/png",
    "image/svg",
    "image/webp",
  ],
  video_Type: [
    'video/mp4',
    'video/webm',
    'video/ogg'
  ]
};
export const offerTypeList = [
  { title: "Percentage", value: "PERCENTAGE" },
  { title: "Flat", value: "FLAT" },
]

export const CouponsInputKeys = {
  couponCode: '',
  offerType: '',
  discountValue: '',
  minOrderValue: '',
  startDate: null,
  endDate: null,
  description: '',
  termsConditions: '',
  maxRedemptionValue: '',
  serviceEligibility: []
}

export const Validation = {
  pattern: {
    NAME: /^[a-zA-Z]+(([',. -][a-zA-Z ])?[a-zA-Z]*)*$/,
    NAMENumber: /^[a-zA-Z0-9]+(([',. -][a-zA-Z0-9 ])?[a-zA-Z0-9]*)*$/,
    CLAIMNUMBER: /^[ A-Za-z0-9]*$/,
    REPORTNAME: /^[ A-Za-z]*$/,
    CODE: /^[ A-Za-z_@./#&+-/'/"]*$/,
    DURATION: /^[0-9]{0,3}$/,
    PRICING: /^[0-9.]{0,30}$/,
    CITY: /^([a-zA-Z\u0080-\u024F]+(?:. |-| |'))*[a-zA-Z\u0080-\u024F]*$/,
    EMAIL: /^(([^<>()\[\]\\.,,:\s@"]+(\.[^<>()\[\]\\.,,:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    POSTAL_CODE: /^\d{5}-\d{4}|\d{4}|[A-Z]\d[A-Z] \d[A-Z]\d$/,
    PHONE_NO: /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,4}$/,
    FIRM_NUMBER: /^[a-z0-9\-]+$/,
    ALPHANUM: /^[a-zA-Z0-9]+$/,
    MOB_NO: /\(?\d{3}\)?-? *\d{3}-? *-?\d{4}/,
    // PASSWORD: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$@$#!%*?&])[A-Za-z\d$@$!%*?&]{6,}/,
    PASSWORD: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$@$#!%*?&])[A-Za-z\d$@#$!%*?&]{6,}/,

    DESCRIPTION: /^[ !@#$%^&*()~:;{}?'"=<>A-Za-z0-9_@./#&+-,-]*$/,
    REFNO: /^[ 0-9_@./#&+-,-]*$/,
    TASK_CODE: /^[0-9999]{1,4}$/,
    SUB_DOMAIN: /^[/a-z/A-Z][a-zA-Z0-9-]*[^/-/./0-9]$/,
    PHONE_NO_MASK: ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/],
    IVR_ACTION_KEY: /^[0-9]*$/,
    IVR_NUMBER: /^[1-9]*$/,
    RADIUS: /^[0-9]*(?:.)([0-9])+$/,
    LATLONG: /^\s*(\-?\d+(\.\d+)?)$/,
    SSN: /^((\d{3}-?\d{2}-?\d{4})|(X{3}-?X{2}-?X{4}))$/,
    SSN_MASK: [/\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/],
    PRACTICE_PASSWORD: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{6,})/,
    USERNAME: /^[a-zA-Z0-9](_(?!(\.|_))|\.(?!(_|\.))|[a-zA-Z0-9]){1,14}[a-zA-Z0-9]$/,
    USERNAME_MIN_SIZ: /^[a-zA-Z0-9_](_(?!(\.|_))|\.(?!(_|\.))|[a-zA-Z0-9_]){4,18}[a-zA-Z0-9_]$/,
    WICARE_USERNAME: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d]{1,}/,
    YEAR_MASK: /d{4}/,
    DECIMAL: /\d+(\.\d{1,2})?/,
    NUMBERnDECIMAL: '^\\d+(\\.\\d+)?$',
    MAXLENGTH: 50,
    MINLENGTH: 3,
    ONLYCHARATERS: /^[aA-zZ\s]+$/,
    ONLYDIGITS: /^[0-9]+$/,
    PASSWORDMINLENGTH: 6,
    PASSWORDMAXLENGTH: 15,
    MINIMUMVACANCY: 1,
    MAXIMUMVACANCY: 2,
    WHITESPACE: /^(?![\s-])[\w\s-]+$/,
    BACKSPACE: /^((?!\s{2,}).)*$/,
    ALPHANUMER: /^[a-zA-Z0-9]+$/,
    // BACKSPACE:.*\\S.*[a-zA-z0-9 ],
    URL: '^(https?:\\/\\/)?' + '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + '((\\d{1,3}\\.){3}\\d{1,3}))' + '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + '(\\?[;&a-z\\d%_.~+=-]*)?' + '(\\#[-a-z\\d_]*)?$',
    phoneRegExp: /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/,
    isValidVideo: /\.(mp4|webm|ogg)$/i,
  }
}
// export const CouponsInputKeys = {
//   couponCode: '',
//   offerType: '',
//   discountValue: '',
//   minOrderValue: '',
//   startDate: null,
//   endDate: null,
//   description: '',
//   termsConditions: '',
//   serviceEligibility: [],
//   maxRedemptionValue: '',
// }
export const countsPerPage = 1000
export const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

let add_ar = "إضافة";
let edit_ar = "تعديل";
let view_ar = "عرض";

export const initialPermissions = {
  vendorManagement: {
    add: { title: "Add", value: true, title_ar: add_ar },
    edit: { title: "Edit", value: true, title_ar: edit_ar },
    view: { title: "View", value: true, title_ar: view_ar },
    title: "Vendor Management",
    title_ar: "عنوان الفلتر"
  },
  templateLibrary: {
    add: { title: "Add", value: true, title_ar: add_ar },
    edit: { title: "Edit", value: true, title_ar: edit_ar },
    view: { title: "View", value: true, title_ar: view_ar },
    title: "Template Library",
    title_ar: "عنوان النموذج"
  },
  setup: {
    add: { title: "Add", value: true, title_ar: add_ar },
    edit: { title: "Edit", value: true, title_ar: edit_ar },
    view: { title: "View", value: true, title_ar: view_ar },
    title: "Setup",
    title_ar: "عنوان الزر"
  },
  teamMember: {
    add: { title: "Add", value: true, title_ar: add_ar },
    edit: { title: "Edit", value: true, title_ar: edit_ar },
    view: { title: "View", value: true, title_ar: view_ar },
    title: "Team Member",
    title_ar: "الخصوصية"
  },
  rolesAndPermission: {
    add: { title: "Add", value: true, title_ar: add_ar },
    edit: { title: "Edit", value: true, title_ar: edit_ar },
    view: { title: "View", value: true, title_ar: view_ar },
    title: "Roles And Permission",
    title_ar: "حجز الفعالية"
  },
  reviewManagement: {
    edit: { title: "Edit", value: true, title_ar: edit_ar },
    view: { title: "View", value: true, title_ar: view_ar },
    title: "Review Management",
    title_ar: "استرداد"
  },
  revenueReport: {
    export: { title: "Export", value: true, title_ar: "تصدير" },
    view: { title: "View", value: true, title_ar: view_ar },
    title: "Revenue Report",
    title_ar: "المدة"
  },
  planManagement: {
    add: { title: "Add", value: true, title_ar: add_ar },
    edit: { title: "Edit", value: true, title_ar: edit_ar },
    view: { title: "View", value: true, title_ar: view_ar },
    title: "Plan Management",
    title_ar: "المبلغ المدفوع"
  },
  paymentManagement: {
    edit: { title: "Edit", value: true, title_ar: edit_ar },
    view: { title: "View", value: true, title_ar: view_ar },
    title: "Payment Management",
    title_ar: "صافي الربح"
  },
  tickets: {
    add: { title: "Add", value: true, title_ar: add_ar },
    edit: { title: "Edit", value: true, title_ar: edit_ar },
    view: { title: "View", value: true, title_ar: view_ar },
    title: "Tickets",
    title_ar: "التذاكر"
  },
  queries: {
    add: { title: "Add", value: true, title_ar: add_ar },
    edit: { title: "Edit", value: true, title_ar: edit_ar },
    view: { title: "View", value: true, title_ar: view_ar },
    title: "Queries",
    title_ar: "اسحب هنا لتعيين المواقع"
  },
  policy: {
    add: { title: "Add", value: true, title_ar: add_ar },
    title: "Policy",
    title_ar: "الرسوم الإضافية"
  },
  notification: {
    add: { title: "Add", value: true, title_ar: add_ar },
    edit: { title: "Edit", value: true, title_ar: edit_ar },
    view: { title: "View", value: true, title_ar: view_ar },
    title: "Notification",
    title_ar: "إجمالي الربح"
  },
  chat: {
    view: { title: "View", value: true, title_ar: view_ar },
    title: "Chat",
    title_ar: "التحقق"
  },
  couponsAndOffers: {
    add: { title: "Add", value: false, title_ar: add_ar },
    edit: { title: "Edit", value: false, title_ar: edit_ar },
    view: { title: "View", value: false, title_ar: view_ar },
    title: "Coupons & Offers",
    title_ar: "كوبونات وعروض"
  }
};


